<script setup>
import { Head, Link, useForm } from '@inertiajs/vue3';
import HsAuthenticationCard from '@/Components/AuthenticationCard.vue';
import HsAuthenticationCardLogo from '@/Components/AuthenticationCardLogo.vue';
import HsButton from '@/Components/Button.vue';
import HsInput from '@/Components/Input.vue';
import HsCheckbox from '@/Components/Checkbox.vue';
import HsValidationErrors from '@/Components/ValidationErrors.vue';

defineProps({
    canResetPassword: Boolean,
    status: String,
    minLength: Number,
    flash: Object,
});

//function to toggle password visibility
const togglePasswordShow = () => {
    const password = document.getElementById('password');
    const toggle = document.getElementById('showicon');

    if (password.type === 'password') {
        password.type = 'text';
        // toggle.classList.add('bx-hide');
        toggle.classList.add('bx-show');
    } else {
        password.type = 'password';
        // toggle.classList.add('bx-show');
        toggle.classList.remove('bx-show');
    }
};

const form = useForm({
    email: '',
    password: '',
    remember: false,
});

const submit = () => {
    form.transform(data => ({
        ...data,
        remember: form.remember ? 'on' : '',
    })).post(route('login'), {
        onFinish: () => form.reset('password'),
    });
};
</script>
<style scoped>
@import "../../../../public/ui/vendor/css/pages/page-auth.css";
</style>
<template>

    <Head title="Sign in to your account" />

    <HsAuthenticationCard>
        <!-- /Left Text -->
        <div class="d-none d-lg-flex col-lg-7 col-xl-8 p-0">

            <div class="w-100 d-flex justify-content-center">
                <div class="card-img-overlay col-lg-7 col-xl-8 text-black">
                    <h2 class="card-title mb-3 text-black">Hotel Space</h2>
                    <p><i class="bx bxs-quote-left"></i> Unleash the power of seamless B2B hotel booking with Hotel
                        Space <i class="bx bxs-quote-right"></i>
                    </p>
                </div>
                <img src="/ui/img/backgrounds/19.jpg" class="img-fluid" alt="Login image" />
            </div>
        </div>
        <!-- /Left Text -->

        <!-- Login -->
        <div class="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
            <div class="w-px-400 mx-auto">
                <!-- Logo -->
                <HsAuthenticationCardLogo />
                <!-- /Logo -->
                <h4 class="mb-2">Sign into your account</h4>
                <p class="mb-4">Please sign-in to your account and start the adventure.</p>
                <HsValidationErrors class="mb-0" />
                <div v-if="flash.message" class="alert alert-danger alert-dismissible" role="alert">
                    <ul class="mb-0">
                        <li>
                            {{ flash.message }}
                        </li>
                    </ul>
                </div>
                <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                    {{ status }}
                </div>
                <form @submit.prevent="submit" class="mb-3">
                    <div class="mb-3">
                        <label for="email" class="form-label">Email address</label>
                        <HsInput type="email" id="email" v-model="form.email" class="form-control"
                            placeholder="Enter your email address" required autofocus tabindex="1" />
                    </div>
                    <div class="mb-3 form-password-toggle">
                        <div class="d-flex justify-content-between">
                            <label class="form-label" for="password">Password</label>
                            <Link v-if="canResetPassword" :href="route('password.request')">
                            <small>Forgot Password?</small>
                            </Link>
                        </div>
                        <div class="input-group input-group-merge">
                            <HsInput id="password" v-model="form.password" type="password" class="form-control"
                                placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                                aria-describedby="password" required autocomplete="current-password" tabindex="2" />
                            <span class="input-group-text cursor-pointer" id="form-alignment-password"
                                @click="togglePasswordShow"><i id="showicon" class="bx bx-hide"></i></span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="form-check">
                            <HsCheckbox v-model:checked="form.remember" name="remember" class="form-check-input" />
                            <label class="form-check-label" for="remember-me"> Remember Me </label>
                        </div>
                    </div>
                    <HsButton class="btn btn-primary d-grid w-100" :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing">
                        Sign in
                    </HsButton>
                </form>

                <!-- <p class="text-center">
                    <span>New on our platform?</span>
                    <a href="auth-register-cover.html">
                        <span>Create an account</span>
                    </a>
                </p> -->
            </div>
        </div>
    </HsAuthenticationCard>
</template>